<template>
 <div class="cat_C021ZONAAS">
   <div class="form-control">
    <div v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de zona</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las zonas</option>        
        <option v-for="(zona,index) in zonas" :value="zona.ZonaId" :key="index">{{zona.Nombre}}</option>
      </select>      
    </div>
  </div>
 </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        zonas: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 021Zonas
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }
        let zonaObj = this.obtenerZonaObj(evento.target.value);
        this.$store.dispatch("A_SINOJ_Catalogos_establecer021Zonas",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento,zonaObj);
        // para obtener label del select => let labelTipoPagina = evento.target.options[evento.target.selectedIndex].text;
      },
      obtenerZonaObj: function(zonaObj) {
        let id = parseInt(zonaObj);
        let zona = null;
        this.zonas.filter(zBD => zBD.ZonaId == id).forEach(z => {zona = z});
        return zona;
      },
      /**
       * Metodo para llenar catalogo 021Zonas mediante el llamado de la API
       */
      cargarZonas: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SINOJ.catalogos.C021TiposZonas;
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetZonasAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);

        axios.post(urlApi, peticionMetodoGetZonasAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        //utilizar solo en etapa de desarrollo 
                       /*  console.log("ejecuto bien::catalogoZona:: ",respuesta.data); */
                        this.zonas = respuesta.data.Zonas;
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SINOJ_Catalogos_establecer021Zonas", valoresDelCatalogo);
    },
    created() {
      this.cargarZonas();
    }
  }
</script>
<style scoped>
.cat_C021ZONAAS .form-control {
    background-color: white !important;
    color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C021Zonas.vue